'use client';

import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import {
  RequestPasswordResetForm,
  type FeedbackMessageBannerProps,
  type RequestPasswordResetFormValues,
} from '@clara/ui';
import { authClient } from '../../../../lib/auth/auth-client';

const REQUEST_FAILED = 'Could not request a password reset link.';

export const RequestPasswordResetPage: React.FC = () => {
  const router = useRouter();

  const [banner, setBanner] = useState<Pick<FeedbackMessageBannerProps, 'variant' | 'message'>>({
    variant: 'info',
    message: "Enter your email address and we'll send you a link to reset your password.",
  });

  const onSubmit = async (data: RequestPasswordResetFormValues) => {
    try {
      const result = await authClient.requestPasswordReset({
        email: data.email.trim(),
        redirectTo: '/change-password',
      });

      if (result?.error) {
        setBanner({
          variant: 'error',
          message: 'message' in result.error ? String(result.error.message) : REQUEST_FAILED,
        });
        return;
      }

      router.push('/request-password-reset/success');
    } catch (err) {
      setBanner({
        variant: 'error',
        message: err instanceof Error ? err.message : REQUEST_FAILED,
      });
    }
  };

  return <RequestPasswordResetForm onSubmit={onSubmit} banner={banner} />;
};

